export const api = "https://developers.zomato.com/api/v2.1/";
export const forkifyApi = "https://forkify-api.herokuapp.com/api/";
